import { Container, Row, Col } from "react-bootstrap"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css";
import java from "../assets/img/java.png";
import git from "../assets/img/git.png";
import postgresql from "../assets/img/postgresql.png";
import python from "../assets/img/python.png";
import html from "../assets/img/html.png";
import css from "../assets/img/css.png";
import node from "../assets/img/node.png";
import js from "../assets/img/js.png";
import react from "../assets/img/react.png";
import linux from "../assets/img/linux.png";
import scala from "../assets/img/scala.png";
import intelliJ from "../assets/img/intelliJ.png"
import spring from "../assets/img/spring.png"
import unix from "../assets/img/unix.png"
import maven from "../assets/img/maven.png"
import spark from "../assets/img/spark.png"
import html_css from "../assets/img/html_css.png"


export const Skills = () => {
    const responsive = {
        superLargeDesktop: {
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 5
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };

       
 

      return (
        <section className="skill" id="skills">
            <Row>
                <Col>
                    <div className="skill-bx">
                        <h2>Skills</h2>
                        <p>Welcome to the skills section! Here, you'll find a showcase of the tools, languages, and technologies I've picked up along the way. From my university courses to personal projects, each skill has played a role in shaping me into the developer I am today.</p>
                        <Carousel 
                          responsive={responsive} 
                          infinte={true}
                          autoPlay={true}
                          autoPlaySpeed={3000}
                          rewind={true} 
                          className="skill-slider">
                            
                            <div className="item">
                                <img src={java} alt="Java" />
                            </div>

                            <div className="item">
                                <img src={scala} alt="Scala" />
                            </div>
                            
                            <div className="item">
                                <img src={python} alt="Python" />
                            </div>

                            <div className="item">
                                <img src={js} alt="JS" />
                            </div>

                            <div className="item">
                                <img src={git} alt="Git" />
                            </div>

                            <div className="item">
                                <img src={postgresql} alt="PostgreSQL" />
                            </div>                        
                            
                            <div className="item">
                                <img src={react} alt="React" />
                            </div>

                            <div className="item">
                                <img src={node} alt="NodeJS" />
                            </div>

                            <div className="item">
                                <img src={spring} alt="Spring" />
                            </div>

                            <div className="item">
                                <img src={linux} alt="Linux" />
                            </div>

                            <div className="item">
                                <img src={unix} alt="Unix" />
                            </div>

                            <div className="item">
                                <img src={maven} alt="Maven" />
                            </div>

                            <div className="item">
                                <img src={spark} alt="Spark" />
                            </div>

                            <div className="item">
                                <img src={intelliJ} alt="IntelliJ" />
                            </div>

                            <div className="item">
                                <img src={html} alt="HTML" />
                            </div>

                            <div className="item">
                                <img src={css} alt="CSS" />
                            </div>                            


                        </Carousel>
                    </div>
                </Col>
            </Row>
        </section>
      )
    }

